<template>
  <v-card flat class="advanced-color-picker">
    <v-card-title class="text-center justify-center py-6">
      <v-btn absolute icon right @click="$emit('back')" color="primary">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-title>

    <v-container class="pa-4">
      <v-row align="center" class="mb-4">
        <v-col cols="12">
          <v-label class="mb-2 d-block">انتخاب رنگ {{ labelText }}</v-label>
          <v-text-field
            v-model="currentColor"
            :label="`کد رنگ ${labelText} (HEX)`"
            prepend-inner-icon="mdi-pound"
            outlined
            dense
            @input="onColorInputChange"
            :rules="[validateHex]"
            class="rounded-lg"
          />
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col
          v-for="(color, i) in colors"
          :key="i"
          class="pa-2"
          cols="3"
          lg="1"
          md="2"
        >
          <v-avatar
            :color="color"
            class="rounded-lg border cursor-pointer color-swatch"
            size="40"
            @click="onColorSwatchClick(color)"
          >
            <v-icon v-if="currentColor === color" color="white" small>
              mdi-check
            </v-icon>
          </v-avatar>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "AdvancedColorPicker",

  props: {
    value: {
      type: Object,
      required: true,
    },
    labelText: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      currentColor: "#EC5252",
      colors: [
        "#EC5252",
        "#C14444",
        "#EF717A",
        "#D95459",
        "#FF8976",
        "#F56149",
        "#F392B9",
        "#EA4C8C",
        "#5E345E",
        "#4F2B4F",
        "#B659AB",
        "#8F3D86",
        "#9B59B6",
        "#8E44AD",
        "#745EC5",
        "#5B48A2",
        "#5065A1",
        "#394C81",
        "#3498DB",
        "#2980B9",
        "#34495E",
        "#2C3E50",
        "#3A6F81",
        "#356272",
        "#345F41",
        "#2D5036",
        "#1ABC9C",
        "#16A085",
        "#2ECC71",
        "#27AE60",
        "#A5C63B",
        "#8EB021",
        "#F5C24E",
        "#FCB424",
        "#F68F30",
        "#C66913",
        "#79302A",
        "#662621",
        "#5E4534",
        "#503B2C",
        "#8E8271",
        "#7B7163",
        "#F0DEB4",
        "#D5C295",
        "#B8C9F1",
        "#48ABD5",
        "#ECF0F1",
        "#BDC3C7",
        "#95A5A6",
        "#7F8C8D",
        "#A0CECB",
        "#7DB1B1",
        "#CFF09E",
        "#A8DBA8",
      ],
    };
  },

  computed: {
    computedValue: {
      get() {
        return this.value || { color: "#D81A1AFF" };
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  watch: {
    value: {
      handler(newValue) {
        if (newValue && newValue.color) {
          this.currentColor = newValue.color;
        }
      },
      immediate: true,
    },
  },

  methods: {
    validateHex(value) {
      return /^#[0-9A-F]{6}$/i.test(value) || "کد HEX نامعتبر است";
    },

    onColorInputChange(color) {
      this.currentColor = color;
      this.setColor(color);
    },

    onColorSwatchClick(color) {
      this.currentColor = color;
      this.setColor(color);
    },

    setColor(color) {
      this.computedValue = { color: color };
      this.$emit("change", "color");
      this.$emit("color-change", {
        type: "color",
        value: color,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.advanced-color-picker {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.color-swatch {
  position: relative;
  transition: all 0.3s ease;
}

.color-swatch:hover {
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

.v-icon {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.color-swatch:hover .v-icon,
.v-icon[selected] {
  opacity: 1;
}

.v-text-field {
  transition: all 0.3s ease;
}

.v-text-field:hover {
  transform: translateY(-2px);
}
</style>
